// prettier-ignore
export const PopularBetsActionTypes = {
  SET_BETS: 'SET_BETS',
  SET_SELECTED_LEAGUES: 'SET_SELECTED_LEAGUES',
  SET_SELECTED_SPORT: 'SET_SELECTED_SPORT'
};
